import { useSelector } from 'react-redux';

import { getScale } from 'libs/common';
import { useWindowSize } from 'libs/hooks';
import { Unrecognized, CallsNotifications } from 'libs/ui';
import { data } from 'services/data';
import { WindowsController } from 'components/windows-controller';
import { WidgetsController } from 'components/widgets-controller';
import { WidgetsDock } from 'components/widgets-dock/widgets-dock';
import { CountersController } from 'components/counters-controller';
import { ZonesMap } from 'components/maps/ZonesMap';
import { Header } from './blocks/header';
import { Content, ContentOther, Position, Position2 } from './page-main-view.styled';

export const PageMainView = (props) => {
  const { unrecognized } = props;
  const withUnrecognized = unrecognized?.source !== undefined;
  const dockEnabled = useSelector((store) => store.widgets.dockEnabled);

  // size
  const size = useWindowSize();
  /**
   * check width
   */
  if (!size.width || !size.height) {
    return null;
  }

  // scale
  const scale = getScale(size);
  const scaleOther = getScale(size, true);
  data.setScale(scaleOther);

  return (
    <>
      <Header />
      <Position className="app-content">
        <Content scale={scale}>
          <ZonesMap />
          <CallsNotifications />
          {withUnrecognized && <Unrecognized data={unrecognized} id={unrecognized.source} />}
          <WidgetsController />
        </Content>
        {/* в DOM между картой и окнами: панель поверх карты, но под открытыми окнами */}
        {dockEnabled && <WidgetsDock />}
        <Position2>
          <ContentOther scale={scaleOther}>
            <WindowsController scale={scaleOther} />
          </ContentOther>
        </Position2>
      </Position>
      {/* <CountersController scale={scaleOther} /> */}
    </>
  );
};
